const isDebugEnabled = (): boolean => {
  if (process.env.NODE_ENV !== 'production') return true;
  try {
    return localStorage.getItem('percy:debug') === '1';
  } catch {
    return false;
  }
};

const debugEnabled = isDebugEnabled();

export const log = {
  debug: (...args: unknown[]): void => {
    if (debugEnabled) console.log(...args);
  },
  info: (...args: unknown[]): void => {
    if (debugEnabled) console.info(...args);
  },
  warn: (...args: unknown[]): void => {
    console.warn(...args);
  },
  error: (...args: unknown[]): void => {
    console.error(...args);
  },
};